import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';

import {
  MembershipBlock,
  NewBillingBlock,
  NewMembershipBlock,
} from './components';
import Loading from '../Loading';

const propTypes = {
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    name: PropTypes.string,
    date_of_birth: PropTypes.string,
    phone_number: PropTypes.string,
    // Commented out as part of ticket to remove Google SSO
    // google: PropTypes.string,
    // facebook: PropTypes.string,
  }).isRequired,
  newPlatform: PropTypes.shape({
    subscription: PropTypes.shape({ status: PropTypes.string }),
    purchases: PropTypes.arrayOf(PropTypes.shape({})),
    initialized: PropTypes.bool,
    loading: PropTypes.bool,
  }),
};

class SubscriptionsSettings extends React.Component {
  render() {
    const { newPlatform } = this.props;

    if (!newPlatform || !newPlatform.initialized || newPlatform.loading)
      return <Loading />;

    const hasAccessOnNewPlatform =
      (newPlatform.subscription && newPlatform.subscription.status) ||
      (newPlatform.purchases && newPlatform.purchases.length > 0);

    return (
      <React.Fragment>
        {hasAccessOnNewPlatform && (
          <NewMembershipBlock title="Membership" {...this.props} />
        )}
        <MembershipBlock
          title="Membership"
          {...this.props}
          hasAccessOnNewPlatform={!!hasAccessOnNewPlatform}
        />

        <NewBillingBlock title="Billing" {...this.props} />
      </React.Fragment>
    );
  }
}

SubscriptionsSettings.propTypes = propTypes;

const mapStateToProps = (state) => ({ newPlatform: state.newPlatform });

export default connect(mapStateToProps)(SubscriptionsSettings);
